const e = "light", t = "dark", r = "green", E = "grey", n = "dark-grey", g = {
  theme: {
    type: String,
    default: e,
    validator: (o) => [e, t, r, E, n].includes(o)
  }
}, s = {
  light: e,
  dark: t,
  green: r,
  grey: E,
  "dark-grey": n
};
export {
  s as themeOptions,
  g as themeProp
};
